<template>
    <div class="card">
        <div class="card-body">
            <div class="row m-2">
                <div class="col-8 p-l-0 title">
                    <img src="/theme/icons/owers-books.svg" class="m-r-20">
                    <span>ЗАБОРГОВАНІ КНИЖКИ</span>
                </div>
                <div class="col-4 p-r-0 text-right" @click="sort = !sort">
                    <img src="/theme/icons/arrow-desc.svg" alt="">
                    <img src="/theme/icons/arrow-asc.svg" alt="">
                    <div class="btn btn-debtor">{{ total}}</div>
                </div>
            </div>
            <hr>
            <div v-for="(book, name, index) in owersBooks">
                <div class="row m-0">
                    <div class="col-8 p-l-0">
                        <template v-if="book.reader">
                            <a @click="$root.searchInLibrary(book.reader.code)" class="reader">
                                <b>{{ book.reader.fullname }}</b>
                            </a>
                        </template>
                        <br>
                        <template v-if="book.description">
                            <a class="book" @click="$root.searchInLibrary(book.code)">
                                {{ book.description.title }}
                            </a>
                        </template>
                    </div>
                    <div class="col-4 p-r-0 text-right">
                        <span class="book">{{ book.back_date }}</span>
<!--                      <br>-->
                        <span class="btn btn-debtor not-debtor">{{Math.floor((new Date().setHours(0,0,0,0) - new Date(book.back_date).setHours(0,0,0,0)) / (1000*60*60*24)) }}</span>
                    </div>
                </div>
                <hr v-if="owersBooks.per_page - 1 != index">
            </div>
          <div class="m-t-20 text-center" @click="getOwersBooks">
            <img src="/theme/icons/more-circle.svg">
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OwersBooks",
        data(){
            return {
                owersBooks:[],
                sort:false,
                page:0,
                total:0,
            }
        },
        mounted() {
            this.getOwersBooks();
          this.$root.$on('back_book', (bvEvent, modalId) => {
            this.page = 0;
            this.getOwersBooks();
          });
        },
        watch:{
          sort(){
            this.page = 0;
            this.owersBooks = [];
            this.getOwersBooks();
          }
        },
        methods:{
            getOwersBooks() {
              this.page++;
              axios.get('/library/owers-books?page='+ this.page + (this.sort ? '&sort=true': ''))
                    .then(response => {
                      let sort = Object.values(response.data.data).sort(function (a,b){
                        if (a.back_date < b.back_date) {
                          return -1;
                        }
                        if (a.back_date > b.back_date) {
                          return 1;
                        }
                        return 0;
                      })
                      if(this.sort){
                        sort = sort.reverse();
                      }
                      if(this.page > 1){
                        this.owersBooks = this.owersBooks.concat(sort);
                      } else{
                        this.owersBooks = sort;
                        this.total = response.data.total;
                      }
                    })
            },
        }
    }
</script>

<style scoped>
    .btn-debtor{
        /*margin-left: 17px;*/
        color: white;
        text-align: center;
        text-transform: uppercase;
        font-size: 12px;
        line-height: 10px;
        height: 24px;
    //width: 40px;
        background-color: #FE9780;
    }
    .rotate{
        transform: rotate(180deg);
    }
    .reader{
        color: #72809D;
        font-size: 16px;
        cursor: pointer;
        font-weight:400;
    }
    .book{
        color: #A7AFBA;
        font-size: 13px;
        padding:unset;
        cursor: pointer;
        display: block;
        /*height: 1em;*/
    }
    .btn-debtor.not-debtor{
       background: #CCCCCC;
    }
</style>